/* NEBULA — JS propio. Todo vanilla, sin librerías. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.nb-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nb-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nb-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { obs.observe(el); });

    // Seguridad: revela de inmediato lo que ya esté en pantalla al cargar.
    requestAnimationFrame(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) { el.classList.add('nb-visible'); obs.unobserve(el); }
      });
    });

    // Último recurso: nada se queda invisible pasados 1,8 s.
    setTimeout(function () {
      document.querySelectorAll('.nb-reveal:not(.nb-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight * 1.3)) el.classList.add('nb-visible');
      });
    }, 1800);
  }

  /* ---------- Parallax suave del hero ---------- */
  function initHeroParallax() {
    var bg = document.querySelector('.nb-hero__bg');
    if (!bg || reduceMotion) return;
    var ticking = false;
    function update() {
      var rect = bg.parentElement.getBoundingClientRect();
      var offset = Math.max(-1, Math.min(1, rect.top / window.innerHeight));
      bg.style.transform = 'translateY(' + (offset * 40) + 'px)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Contadores animados ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-nb-count]');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = el.getAttribute('data-nb-count'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-nb-count'));
        var suffix = el.getAttribute('data-nb-suffix') || '';
        var dur = 1400, start = null;
        if (reduceMotion) { el.textContent = target.toLocaleString('es-ES') + suffix; obs.unobserve(el); return; }
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString('es-ES') + suffix;
          if (p < 1) window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
        obs.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Galería de la página de producto ---------- */
  function initPdpGallery() {
    var main = document.querySelector('.nb-pdp__main-img img');
    var thumbs = document.querySelectorAll('.nb-pdp__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (full) main.src = full;
        var alt = btn.querySelector('img');
        if (alt) main.alt = alt.alt;
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Selector de variantes (si las hubiera) ---------- */
  function initVariants() {
    var root = document.querySelector('[data-nb-variants]');
    if (!root) return;
    var data;
    try { data = JSON.parse(document.getElementById('nb-variant-data').textContent); }
    catch (e) { return; }
    var selects = root.querySelectorAll('select[data-nb-option]');
    var idInput = root.querySelector('input[name="id"]');
    var priceNow = document.querySelector('[data-nb-price-now]');
    var priceWas = document.querySelector('[data-nb-price-was]');
    var atc = root.querySelector('[data-nb-atc]');
    if (!selects.length) return;

    function currentOptions() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }
    function money(cents) {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
    function update() {
      var opts = currentOptions();
      var match = data.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceNow) priceNow.textContent = money(match.price);
      if (priceWas) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceWas.textContent = money(match.compare_at_price);
          priceWas.style.display = '';
        } else { priceWas.style.display = 'none'; }
      }
      if (atc) {
        if (match.available) { atc.disabled = false; atc.textContent = atc.getAttribute('data-label-add'); }
        else { atc.disabled = true; atc.textContent = atc.getAttribute('data-label-sold'); }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  function boot() {
    initReveals();
    initHeroParallax();
    initCounters();
    initPdpGallery();
    initVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
